module.exports = __webpack_public_path__ + "img/lena.95de4c3e.png";